import { render, staticRenderFns } from "./veJkyFundShow.vue?vue&type=template&id=e2d415c2&scoped=true"
import script from "./veJkyFundShow.vue?vue&type=script&lang=js"
export * from "./veJkyFundShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d415c2",
  null
  
)

export default component.exports